import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-banner',
    templateUrl: 'banner.component.html'
})

export class BannerComponent implements OnInit, AfterViewInit {

    banner: any;
    links: any;
    ref1: any;
    ref2: any;
    topCatalog: Observable<any>;
    @ViewChild('favMenu') favMenu: ElementRef;
    @ViewChild('modalPayment') modalPayment;
    @ViewChild('invoiceExpired') invoiceExpiredModal;
    isPaymentError: boolean;
    baseHref;

    constructor(private http: HttpClient, private sanitizer: DomSanitizer,private router: Router) {
        this.baseHref = environment.baseHref.substr(0, environment.baseHref.length - 1);
     }

    ngOnInit() {
        this.banner = this.http.get('api/posts/link/main');
        this.topCatalog = this.http.get('api/common/getTopCatalog?total=6&searchStr=&sort=');
        jQuery('#carousel-example-generic').carousel({
            interval: 5000,
          })
    }

    ngAfterViewInit(): void {
      Layout.initTheme();
    }

    getThumbnail(post) {
        let img = (post.meta as any[]).find(i => i.key == "attach_fileinfo_id");
        return img ? `files/posts/${img.id}.png` : undefined;
    }

    getThumbnail2(url) {
        let url2 = this.getThumbnail(url);
        return this.sanitizer.bypassSecurityTrustStyle(`url(${url2})`);
    }

    goLink(url) {
      window.location.href = url;
    }

    onSubmit(){
        this.http.post("api/payment/redirect/wizard3/"+this.ref1+"/"+this.ref2,null,{responseType:'text'}).subscribe((res: any)=>{
            if(res == 'invoice is expired'){
                jQuery(this.invoiceExpiredModal.nativeElement).modal().show();
            }else{
                window.location.href = res;
            }
        }, (err: any) => {
            this.showDialog(true);
        });
    }

    showDialog(isPaymentError: boolean) {
        this.isPaymentError = isPaymentError;
        this.showRegisterDialog();
    }
    showRegisterDialog() {
        jQuery(this.modalPayment.nativeElement).modal().show();
    }

    goToUrl(url){
        this.router.navigateByUrl(url);
    }
}



// WEBPACK FOOTER //
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/app/home/banner.component.ts